import React, { useState, useMemo } from 'react'
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  TextField,
  Select,
  MenuItem,
} from '@mui/material'
import SideBar from '../components/layout/SideBar'
import Footer from '../components/Footer'
// import { ReactComponent as ListViewIcon } from '../assets/listViewIcon.svg'
// import { ReactComponent as CardViewIcon } from '../assets/cardViewIcon.svg'
import { ReactComponent as ExportIcon } from '../assets/exportIcon.svg'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import { useSelector } from 'react-redux'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious'
import SkipNextIcon from '@mui/icons-material/SkipNext'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import * as XLSX from 'xlsx'

import SearchIcon from '@mui/icons-material/Search'

const DirectoryScreen = () => {
  const associates = useSelector((state) => state.associates.associates)

  const [currentPage, setCurrentPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [searchTerm, setSearchTerm] = useState('')
  const [sortOrder, setSortOrder] = useState({ column: 'bidid', order: 'asc' })

  const startIndex = (currentPage - 1) * rowsPerPage
  const endIndex = startIndex + rowsPerPage

  // sort
  const filteredAssociates = useMemo(() => {
    const associatesCopy = [...associates]

    if (sortOrder.column === 'bidid') {
      associatesCopy.sort((a, b) =>
        sortOrder.order === 'asc'
          ? parseInt(a.bidid.split('-').pop()) -
            parseInt(b.bidid.split('-').pop())
          : parseInt(b.bidid.split('-').pop()) -
            parseInt(a.bidid.split('-').pop())
      )
    } else if (sortOrder.column === 'designation') {
      associatesCopy.sort((a, b) =>
        sortOrder.order === 'asc'
          ? a.designation.localeCompare(b.designation)
          : b.designation.localeCompare(a.designation)
      )
    } else if (sortOrder.column === 'name') {
      associatesCopy.sort((a, b) =>
        sortOrder.order === 'asc'
          ? a.name.localeCompare(b.name)
          : b.name.localeCompare(a.name)
      )
    } else if (sortOrder.column === 'dateofjoin') {
      associatesCopy.sort((a, b) =>
        sortOrder.order === 'asc'
          ? a.name.localeCompare(b.dateofjoin)
          : b.name.localeCompare(a.dateofjoin)
      )
    } else if (sortOrder.column === 'email') {
      associatesCopy.sort((a, b) =>
        sortOrder.order === 'asc'
          ? a.email.localeCompare(b.email)
          : b.email.localeCompare(a.email)
      )
    } else if (sortOrder.column === 'phoneNumber1') {
      associatesCopy.sort((a, b) =>
        sortOrder.order === 'asc'
          ? a.phone1.localeCompare(b.phone1)
          : b.phone1.localeCompare(a.phone1)
      )
    } else if (sortOrder.column === 'sponsoredBy') {
      associatesCopy.sort((a, b) =>
        sortOrder.order === 'asc'
          ? a.sponsoredBy.localeCompare(b.sponsoredBy)
          : b.sponsoredBy.localeCompare(a.sponsoredBy)
      )
    }

    return associatesCopy.filter((associate) =>
      [
        associate.bidid,
        associate.designation,
        associate.name,
        associate.email,
        associate.phone1,
        associate.sponsoredBy,
      ]
        .join(' ')
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    )
  }, [associates, searchTerm, sortOrder])

  // Pagination of filtered data
  const totalPages = Math.ceil(filteredAssociates.length / rowsPerPage)
  const paginatedAssociates = useMemo(() => {
    const startIndex = (currentPage - 1) * rowsPerPage
    return filteredAssociates.slice(startIndex, startIndex + rowsPerPage)
  }, [filteredAssociates, currentPage, rowsPerPage])

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page)
    }
  }

  const handleSkipToFirst = () => {
    setCurrentPage(1)
  }

  const handleSkipToLast = () => {
    setCurrentPage(totalPages)
  }

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(event.target.value)
    setCurrentPage(1)
  }
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value)
    setCurrentPage(1)
  }

  const handleSort = (column) => {
    setSortOrder((prev) => ({
      column,
      order: prev.column === column && prev.order === 'asc' ? 'desc' : 'asc',
    }))
  }

  const handleExport = () => {
    const exportData = associates.map(({ _id, ...rest }) => rest)

    const worksheet = XLSX.utils.json_to_sheet(exportData)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Associates')
    XLSX.writeFile(workbook, 'AssociatesData.xlsx')
  }

  return (
    <>
      <Box sx={{ display: 'flex', height: '98vh' }}>
        <SideBar />
        {/* parent */}
        <Box
          component='main'
          sx={{
            flexGrow: 1,
            marginBottom: 2,
            marginRight: 2,
            marginTop: 9,
            display: 'flex',
            flexDirection: 'column',
            paddingLeft: 2,
          }}>
          {/* first Box */}

          <Box
            sx={{
              width: '100%',
              height: '100%',
              padding: 1,
              background: '#F6FAFF',
              borderRadius: '20px',
              overflow: 'hidden',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
              display: 'flex',
            }}>
            {/* associate Box */}
            <Box
              sx={{
                width: '100%',
                padding: 0,
                backgroundColor: '#F6FAFF',
                borderRadius: 2,
                display: 'flex',
              }}>
              <Box
                sx={{
                  width: '100%',
                  padding: 0,
                  background: '#F6FAFF',
                  borderRadius: 2,
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  paddingTop: '18px',
                  paddingLeft: '12px',
                }}>
                <Typography
                  sx={{
                    color: '#F6764E',
                    fontSize: 20,
                    fontWeight: 600,
                    wordWrap: 'break-word',
                    marginRight: '24px',
                  }}>
                  Directory
                </Typography>
              </Box>
            </Box>
            {/* record/page box */}
            <Box
              sx={{
                width: '100%',
                backgroundColor: '#F6FAFF',
                display: 'flex',
              }}>
              <Box
                sx={{
                  width: '100%',
                  background: '#F6FAFF',
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  paddingLeft: '12px',
                }}>
                <Typography
                  sx={{
                    color: '#081332',
                    fontSize: 18,
                    fontWeight: 500,
                    wordWrap: 'break-word',
                    marginRight: '11px',
                    fontFamily: 'Work Sans',
                  }}>
                  Records Per Page:
                </Typography>
                <Box>
                  <Select
                    value={rowsPerPage}
                    onChange={handleRowsPerPageChange}
                    displayEmpty
                    IconComponent={ArrowDropDownIcon}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      backgroundColor: '#FFFFFF',
                      borderRadius: '2px',
                      px: 2,
                      py: 0,
                      height: '36px',
                      boxShadow: 3,
                    }}>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={30}>30</MenuItem>
                  </Select>
                </Box>
                <IconButton onClick={handleExport}>
                  <ExportIcon />
                </IconButton>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  boxShadow: 3,
                  borderRadius: '20px',
                  backgroundColor: 'white',
                  height: '36px',
                  width: '520px',
                }}>
                <SearchIcon sx={{ fontSize: '20px', ml: 2 }} />
                <TextField
                  variant='standard'
                  placeholder='Search...'
                  value={searchTerm}
                  onChange={handleSearchChange}
                  InputProps={{
                    disableUnderline: true,
                    inputProps: {
                      style: {
                        padding: 0,
                      },
                    },
                  }}
                  sx={{ ml: 1, height: '20px', width: '100%' }}
                />
              </Box>
            </Box>
            {/* main table Box */}
            <Box
              sx={{
                width: '100%',
                padding: 0,
                margin: 0,
                background: '#F6FAFF',
                borderRadius: 2,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-start',
                height: '60vh',
              }}>
              <TableContainer
                sx={{
                  maxHeight: '60vh',
                  '&::-webkit-scrollbar': {
                    width: '8px',
                  },
                  '&::-webkit-scrollbar-track': {
                    background: '#f1f1f1',
                    borderRadius: '10px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: '#AAB4C6',
                    borderRadius: '10px',
                    border: '2px solid #f1f1f1',
                  },
                  '&::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: '#555',
                  },
                }}>
                <Table
                  stickyHeader
                  sx={{
                    minWidth: 650,
                    backgroundColor: '#F6FAFF',
                  }}
                  aria-label='simple table'>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{
                          fontFamily: 'Work Sans',
                          color: '#081332',
                          fontSize: 18,
                          fontWeight: 500,
                          borderBottom: 'none',
                          paddingTop: '0px',
                          paddingBottom: '16px',
                          paddingLeft: '12px',
                          paddingRight: '0',
                          backgroundColor: '#F6FAFF',
                        }}>
                        <Box
                          display='flex'
                          alignItems='center'
                          boxSizing='content-box'>
                          BID-ID
                          <IconButton
                            size='small'
                            sx={{
                              marginLeft: '10px',
                              marginRight: '0',
                            }}
                            onClick={() => handleSort('bidid')}>
                            {sortOrder.column === 'bidId' &&
                            sortOrder.order === 'asc' ? (
                              <ArrowUpwardIcon
                                sx={{
                                  color:
                                    sortOrder.column === 'bidid'
                                      ? '#F6764E'
                                      : '#FBBAB1',
                                }}
                              />
                            ) : (
                              <ArrowDownwardIcon
                                sx={{
                                  color:
                                    sortOrder.column === 'bidid'
                                      ? '#F6764E'
                                      : '#FBBAB1',
                                }}
                              />
                            )}
                          </IconButton>
                        </Box>
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily: 'Work Sans',
                          color: '#081332',
                          fontSize: 18,
                          fontWeight: 500,
                          borderBottom: 'none',
                          paddingTop: '0px',
                          paddingBottom: '16px',
                          paddingLeft: '12px',
                          paddingRight: '0',
                          backgroundColor: '#F6FAFF',
                        }}>
                        <Box display='flex' alignItems='center'>
                          Designation
                          <IconButton
                            size='small'
                            sx={{ marginLeft: '10px' }}
                            onClick={() => handleSort('designation')}>
                            {sortOrder.column === 'designation' &&
                            sortOrder.order === 'asc' ? (
                              <ArrowUpwardIcon
                                sx={{
                                  color:
                                    sortOrder.column === 'designation'
                                      ? '#F6764E'
                                      : '#FBBAB1',
                                }}
                              />
                            ) : (
                              <ArrowDownwardIcon
                                sx={{
                                  color:
                                    sortOrder.column === 'designation'
                                      ? '#F6764E'
                                      : '#FBBAB1',
                                }}
                              />
                            )}
                          </IconButton>
                        </Box>
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily: 'Work Sans',
                          color: '#081332',
                          fontSize: 18,
                          fontWeight: 500,
                          borderBottom: 'none',
                          paddingTop: '0px',
                          paddingBottom: '16px',
                          paddingLeft: '12px',
                          paddingRight: '0',
                          backgroundColor: '#F6FAFF',
                        }}>
                        <Box display='flex' alignItems='center'>
                          Name
                          <IconButton
                            size='small'
                            sx={{ marginLeft: '10px' }}
                            onClick={() => handleSort('name')}>
                            {sortOrder.column === 'name' &&
                            sortOrder.order === 'asc' ? (
                              <ArrowUpwardIcon
                                sx={{
                                  color:
                                    sortOrder.column === 'name'
                                      ? '#F6764E'
                                      : '#FBBAB1',
                                }}
                              />
                            ) : (
                              <ArrowDownwardIcon
                                sx={{
                                  color:
                                    sortOrder.column === 'name'
                                      ? '#F6764E'
                                      : '#FBBAB1',
                                }}
                              />
                            )}
                          </IconButton>
                        </Box>
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily: 'Work Sans',
                          color: '#081332',
                          fontSize: 18,
                          fontWeight: 500,
                          borderBottom: 'none',
                          paddingTop: '0px',
                          paddingBottom: '16px',
                          paddingLeft: '12px',
                          paddingRight: '0',
                          backgroundColor: '#F6FAFF',
                        }}>
                        <Box display='flex' alignItems='center'>
                          Date Of Join
                          <IconButton
                            size='small'
                            sx={{ marginLeft: '10px' }}
                            onClick={() => handleSort('dateofjoin')}>
                            {sortOrder.column === 'dateofjoin' &&
                            sortOrder.order === 'asc' ? (
                              <ArrowUpwardIcon
                                sx={{
                                  color:
                                    sortOrder.column === 'dateofjoin'
                                      ? '#F6764E'
                                      : '#FBBAB1',
                                }}
                              />
                            ) : (
                              <ArrowDownwardIcon
                                sx={{
                                  color:
                                    sortOrder.column === 'dateofjoin'
                                      ? '#F6764E'
                                      : '#FBBAB1',
                                }}
                              />
                            )}
                          </IconButton>
                        </Box>
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily: 'Work Sans',
                          color: '#081332',
                          fontSize: 18,
                          fontWeight: 500,
                          borderBottom: 'none',
                          paddingTop: '0px',
                          paddingBottom: '16px',
                          paddingLeft: '12px',
                          paddingRight: '0',
                          backgroundColor: '#F6FAFF',
                        }}>
                        <Box display='flex' alignItems='center'>
                          Email
                          <IconButton
                            size='small'
                            onClick={() => handleSort('email')}>
                            {sortOrder.column === 'email' &&
                            sortOrder.order === 'asc' ? (
                              <ArrowUpwardIcon
                                sx={{
                                  color:
                                    sortOrder.column === 'email'
                                      ? '#F6764E'
                                      : '#FBBAB1',
                                }}
                              />
                            ) : (
                              <ArrowDownwardIcon
                                sx={{
                                  color:
                                    sortOrder.column === 'email'
                                      ? '#F6764E'
                                      : '#FBBAB1',
                                }}
                              />
                            )}
                          </IconButton>
                        </Box>
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily: 'Work Sans',
                          color: '#081332',
                          fontSize: 18,
                          fontWeight: 500,
                          borderBottom: 'none',
                          paddingTop: '0px',
                          paddingBottom: '16px',
                          paddingLeft: '12px',
                          paddingRight: '0',
                          backgroundColor: '#F6FAFF',
                        }}>
                        <Box display='flex' alignItems='center'>
                          Phone
                          <IconButton
                            size='small'
                            onClick={() => handleSort('phone1')}>
                            {sortOrder.column === 'phone1' &&
                            sortOrder.order === 'asc' ? (
                              <ArrowUpwardIcon
                                sx={{
                                  color:
                                    sortOrder.column === 'phone1'
                                      ? '#F6764E'
                                      : '#FBBAB1',
                                }}
                              />
                            ) : (
                              <ArrowDownwardIcon
                                sx={{
                                  color:
                                    sortOrder.column === 'phone1'
                                      ? '#F6764E'
                                      : '#FBBAB1',
                                }}
                              />
                            )}
                          </IconButton>
                        </Box>
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily: 'Work Sans',
                          color: '#081332',
                          fontSize: 18,
                          fontWeight: 500,
                          borderBottom: 'none',
                          paddingTop: '0px',
                          paddingBottom: '16px',
                          paddingLeft: '12px',
                          paddingRight: '0',
                          backgroundColor: '#F6FAFF',
                        }}>
                        <Box display='flex' alignItems='center'>
                          Sponsored By
                          <IconButton
                            size='small'
                            onClick={() => handleSort('sponsoredBy')}>
                            {sortOrder.column === 'sponsoredBy' &&
                            sortOrder.order === 'asc' ? (
                              <ArrowUpwardIcon
                                sx={{
                                  color:
                                    sortOrder.column === 'sponsoredBy'
                                      ? '#F6764E'
                                      : '#FBBAB1',
                                }}
                              />
                            ) : (
                              <ArrowDownwardIcon
                                sx={{
                                  color:
                                    sortOrder.column === 'sponsoredBy'
                                      ? '#F6764E'
                                      : '#FBBAB1',
                                }}
                              />
                            )}
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedAssociates.map((associate) => (
                      <TableRow
                        key={associate._id}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 },
                        }}>
                        <TableCell
                          component='th'
                          scope='row'
                          sx={{
                            borderBottom: 'none',
                            paddingTop: '0px',
                            paddingBottom: '12px',
                          }}>
                          {associate.bidid}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: 'none',
                            paddingTop: '0px',
                            paddingBottom: '12px',
                          }}>
                          {associate.designation}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: 'none',
                            paddingTop: '0px',
                            paddingBottom: '12px',
                          }}>
                          {associate.name}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: 'none',
                            paddingTop: '0px',
                            paddingBottom: '12px',
                          }}>
                          {associate.dateOfJoin}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: 'none',
                            paddingTop: '0px',
                            paddingBottom: '12px',
                          }}>
                          {associate.email}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: 'none',
                            paddingTop: '0px',
                            paddingBottom: '12px',
                          }}>
                          {associate.phoneNumber1}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: 'none',
                            paddingTop: '0px',
                            paddingBottom: '12px',
                          }}>
                          {associate.sponsoredBy}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            {/* pagination Box */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                paddingTop: 2,
                width: '100%',
              }}>
              <Box>
                <Typography
                  variant='body1'
                  sx={{ fontWeight: 'bold', color: '#000000' }}>
                  {`${
                    filteredAssociates.length === 0 ? 0 : startIndex + 1
                  } - ${Math.min(endIndex, filteredAssociates.length)} of ${
                    filteredAssociates.length
                  } records`}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <IconButton
                  sx={{ color: currentPage === 1 ? '#FFA88D80' : '#F6764E' }}
                  onClick={handleSkipToFirst}
                  disabled={currentPage === 1}>
                  <SkipPreviousIcon />
                </IconButton>

                <IconButton
                  sx={{ color: currentPage === 1 ? '#FFA88D80' : '#F6764E' }}
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}>
                  <ChevronLeftIcon />
                </IconButton>

                <IconButton
                  sx={{ color: '#F6764E' }}
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}>
                  <ChevronRightIcon />
                </IconButton>

                <IconButton
                  sx={{ color: '#F6764E' }}
                  onClick={handleSkipToLast}
                  disabled={currentPage === totalPages}>
                  <SkipNextIcon />
                </IconButton>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Footer */}
      <Box component='footer' sx={{ height: '10px' }}>
        <Footer />
      </Box>
    </>
  )
}

export default DirectoryScreen
